import Component_DynamicTerrain_e8ae27778933889e4323004338facca6 from "../../../../content/examples/basic/dynamic-terrain/DynamicTerrain";
import Devtool_DynamicTerrain_e8ae27778933889e4323004338facca6 from "!!@devtool/loader!../../../../content/examples/basic/dynamic-terrain/DynamicTerrain";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_DynamicTerrain_e8ae27778933889e4323004338facca6,
  Devtool_DynamicTerrain_e8ae27778933889e4323004338facca6,
  DevTool,
  React
};